import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import "../../styles/base/baseline.css";
import "../../styles/module/landing-page.css";
import "../../styles/module/scroll-down.css";
import "../../styles/module/services.css";

import "../../styles/pages/home.css";

import About from "../module/About";
import Services from "../module/Services";
import Process from "../module/Process";

import bg from "../../assets/images/img/bg.webp";
import bg2 from "../../assets/images/img/bg-2.webp";
import arrow from "../../assets/images/img/downarrow.webp";
// import RecentPost from "../module/Recent-Post";
// import Modal from "../module/Modal";

export default function Home() {
  useScrollReveal("slide-from-left");
  useScrollReveal("slide-from-right");
  return (
    <>
    {/* <Modal /> */}
      <div className="main-wrapper">
        <img
          alt="scrollDown"
          src={bg2}
          className=" landing__image-background-2 image-background slide-from-left"
        />
        <div className="rotated-text" onClick={() => window.location.href = '#scroll'}>
          <img
            src={arrow}
            alt="downarrow"
            className=""
          />
          <h4>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>{' '}scroll down</font>
            </font>
          </h4>
        </div>
        <div className="section__landing">
          <picture>
            <source
              media="(max-width: 650px)"
              srcSet={bg}
            />
            <img
              alt="container bg"
              src={bg}
              className="landing__image-background-1 image-background slide-from-right"
            />
          </picture>
          <div className="container slide-from-left">
            <div className="logo-gradient"> </div>
            <div className="content">
              <h1 style={{ marginBottom: "30px" }}>
                Building Smarter Systems for Smarter Tomorrow.
              </h1>
              <p style={{ marginBottom: "40px" }}>
                From concept and branding to custom web and mobile solutions —
                we build complete digital experiences that elevate your brand,
                engage your audience, and accelerate growth.
              </p>
              <button
                onClick={() => (window.location.href = "/services")}
                className="btn blue"
              >
                Our Services
              </button>
            </div>
          </div>
        </div>
      </div>

      <About />
      <Services />
      <Process />
      {/* <RecentPost /> */}
    </>
  );
}
